exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "svg .axis-bottom .tick line,svg .axis-left .tick line{stroke:rgba(0,0,0,.2)}svg .domain{display:none}svg .tick{font-family:Source Sans Pro}svg .tick text{font-size:.75rem;font-weight:500;fill:rgba(0,0,0,.4)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/components/pollChart/PollChart.scss
 ** module id = 150
 ** module chunks = 0
 **/